import React from 'react';
import { FormTemplateQuestionFieldsKindEnum } from 'graphql-common';
import Input from '@lib/components/Input/Input';
import { InputTypes } from '@lib/components/Input/enums';
import { ComponentProps, defaultProps } from '../types';

export default function InputPreview({ t }: ComponentProps) {
  return (
    <Input
      type={InputTypes.text}
      label={t('single-line-value')}
      name={`${FormTemplateQuestionFieldsKindEnum.Input}-preview`}
      {...defaultProps}
    />
  );
}
